import NewsLetter from '@/models/NewsLetter'
import map from 'lodash/map'
import Api from '@/services/api'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {}
  },

  mutations: {
    setNewsLetterList (state, subscriptions) {
      state.list = map(subscriptions, (subscription) => {
        if (subscription instanceof NewsLetter) {
          return subscription
        } else {
          return new NewsLetter(subscription)
        }
      })
    },

    setNewsLetterListMeta (state, meta) {
      state.listMeta = meta
    }
  },

  actions: {
    async getNewsLetter ({ commit }, params) {
      const query = NewsLetter.page(params.page || 1).orderBy('-created_at')

      if (params.search) {
        query.where('search', params.search)
      }

      const res = await query.get()

      commit('setNewsLetterList', res.data)
      commit('setNewsLetterListMeta', res.meta)
    },

    async exportToExcel () {
      await Api.get('admin/news-letter/export', { responseType: 'blob' })
        .then(response => {
          const url = URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.ms-excel'
          }))

          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'newsletter-subscriptions.csv')
          document.body.appendChild(link)
          link.click()
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
